import { useDispatch, useSelector } from 'react-redux';

// Use the following hooks intead of `useDispatch` and `useSelector` throughout the codebase.
export const useAppDispatch = useDispatch.withTypes();
export const useAppSelector = useSelector.withTypes();
